import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import SideBar from "../other/SideBar";
import NavBar from "../other/NavBar";
import {
  AddStaffRoleURL,
  getStaffTypeListUrl,
  
  UpdateStaffRoleURL,
} from "../../assets/api/BaseURL";
import LoadingModal from "../../loader/LoadingModal";
import Notification from "../other/Notification";
import { useToast } from "../../../context/ToastContext";
import axios from "axios";

const AddStaffRoll = () => {
  const navigate = useNavigate();
  const { addToast } = useToast();

  const [token, setToken] = useState("");
  const [toggleSideBar, setToggleSideBar] = useState(false);
  const [canvas, setCanvas] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [roleName, setRoleName] = useState("");
  const [permissions, setPermissions] = useState([]);

  const [roleList, setRoleList] = useState([]);
  const [isEditMode, setIsEditMode] = useState(false);
  const [editRoleId, setEditRoleId] = useState(null);

  const handleToggleSidebar = (e) => {
    e.preventDefault();
    setToggleSideBar(!toggleSideBar);
  };

  const handleToggleOffCanvas = (e) => {
    e.preventDefault();
    setCanvas(!canvas);
  };

  const handleBackClick = (e) => {
    e.preventDefault();
    navigate("/view_staff");
  };

  const handlePermissionChange = (id) => {
    const updatedPermissions = permissions.map((perm) =>
      perm.id === id ? { ...perm, permission: !perm.permission } : perm
    );
    setPermissions(updatedPermissions);
  };

  const handleEditRole = (role) => {
    setIsEditMode(true);
    setEditRoleId(role.id);
    setRoleName(role.name);

    let parsedPermissions = [];
    try {
      parsedPermissions = JSON.parse(role.permission || "[]");
    } catch (err) {
      console.error("Permission parsing failed", err);
      addToast("error", "Invalid permission format in selected role");
      return;
    }

    const updatedPermissions = permissions.map((perm) => {
      const matched = parsedPermissions.find((p) => p.name === perm.name);
      return { ...perm, permission: matched?.permission || false };
    });

    setPermissions(updatedPermissions);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!roleName.trim()) {
      addToast("error", "Enter role name");
      return;
    }

    const dataToSend = {
      id:editRoleId,
      name: roleName.trim(),
      permissions: permissions.map((perm) => ({
        id: perm.id,
        name: perm.name,
        permission: perm.permission,
        label: perm.label,
      })),
    };

    try {
      setIsLoading(true);

      const response = await axios({
        method: isEditMode ? "put" : "post",
        url: isEditMode ? `${UpdateStaffRoleURL}` : AddStaffRoleURL,
        data: dataToSend,
        headers: {
          authorization: `Bearer ${token}`,
        },
      });

      if (response.status === 200 && response.data.message) {
        addToast("success", response.data.message);
        setIsEditMode(false);
        setEditRoleId(null);
        setRoleName("");
        setPermissions((prev) => prev.map((p) => ({ ...p, permission: false })));
        fetchRoles(); // Refresh role list
      }
    } catch (error) {
      if (error.response?.data?.message) {
        addToast("error", error.response.data.message);
      } else {
        addToast("error", error.message);
      }
    } finally {
      setIsLoading(false);
    }
  };

  const fetchRoles = async () => {
    try {
      const response = await axios.get(
       getStaffTypeListUrl,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (response.status === 200 && response.data.staffRoles) {
        setRoleList(response.data.staffRoles);
      }
    } catch (err) {
      console.log("Failed to fetch staff type list:", err);
    }
  };

  useEffect(() => {
    if (!localStorage.getItem("token")) {
      navigate("/auth");
    }
  }, [navigate]);

  useEffect(() => {
    const t = localStorage.getItem("token");
    setToken(t);
  }, []);

  useEffect(() => {
    if (token) {
      fetchRoles();
    }
  }, [token]);


  

  useEffect(() => {
    const samplePermissions = [
      { id: 1, name: "live_orders", label: "View Orders", permission: false },
      { id: 2, name: "menu_products", label: "Edit Staff", permission: false },
      { id: 3, name: "staff_manager", label: "Manage Inventory", permission: false },
      { id: 4, name: "orders", label: "Orders", permission: false },
      { id: 5, name: "inventory", label: "Inventory", permission: false },
      { id: 6, name: "pos", label: "POS", permission: false },
      { id: 7, name: "fooder_cp", label: "Fooder CP", permission: false },
      { id: 8, name: "customers", label: "Customers", permission: false },
      { id: 9, name: "manage_tables", label: "Manage Tables", permission: false },
      
    ];
    setPermissions(samplePermissions);
  }, []);









  
  return (
    <>
      {token && (
        <div
          className={
            toggleSideBar
              ? "container-scroller sidebar-icon-only"
              : "container-scroller"
          }
        >
          <nav className="navbar default-layout col-lg-12 col-12 p-0 fixed-top d-flex align-items-top flex-row">
            <div className="text-center navbar-brand-wrapper d-flex align-items-center justify-content-start">
              <Link className="navbar-brand brand-logo-mini" to="/fooders_cp">
               {/* <img src="images/mini-kr-logo.svg" alt="logo" />     */}
              </Link>
              <div className="me-1">
                <button
                  className={
                    toggleSideBar
                      ? "navbar-toggler navbar-toggler align-self-center"
                      : "navbar-toggler navbar-toggler align-self-center text-white"
                  }
                  type="button"
                  onClick={handleToggleSidebar}
                >
                  <span className="icon-menu"></span>
                </button>
              </div>
              <div>
                <Link to="/fooders_cp">
                  <span className="navbar-brand brand-logo">
                    <img src="images/vyfoo_logo.png" alt="logo" />
                  </span>
                </Link>
              </div>
            </div>
            <NavBar
              handleToggle={handleToggleOffCanvas}
              toggleCanvas={toggleSideBar}
            />
          </nav>

          <div className="container-fluid page-body-wrapper px-0">
            <SideBar active="view_staff" toggleCanvas={toggleSideBar} />

            <div className="main-panel">
              <div className="content-wrapper">
                <div className="row">
                  <div className="col-sm-12">
                    <div className="d-flex justify-content-between align-items-start mb-2">
                      <div className="vsalign">
                        <h3 className="ukhd mb-3">
                          {isEditMode ? "Edit Role" : "Add Role"}
                        </h3>
                      </div>
                      <div className="vsalign">
                        <span
                          className="btn btn-danger mb-0 me-0"
                          onClick={handleBackClick}
                        >
                          <i className="menu-icon mdi mdi-arrow-left vsalign"></i>
                          Go Back
                        </span>
                      </div>
                    </div>

                    {/* Role List */}
                    <div className="mb-4">
                      <h5>Existing Roles</h5>
                      <div className="row">
                        {roleList.map((role) => (
                          <div key={role.id} className="col-md-4 mb-3">
                            <div className="card shadow-sm h-100">
                              <div className="card-body">
                                <h5 className="card-title">{role.name}</h5>
                                <p className="card-text">
                                  Permissions:{" "}
                                  {(() => {
                                    try {
                                      const perms = JSON.parse(role.permission || "[]");
                                      return perms
                                        .filter((p) => p.permission)
                                        .map((p) => p.label)
                                        .join(", ") || "None";
                                    } catch {
                                      return "Invalid Permissions";
                                    }
                                  })()}
                                </p>
                                <button
                                  className="btn btn-sm btn-primary"
                                  onClick={() => handleEditRole(role)}
                                >
                                  Edit Role
                                </button>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>

                    </div>

                    {/* Form */}
                    <div className="row">
                      <div className="col-lg-12 d-flex flex-column">
                        <div className="row flex-grow">
                          <div className="col-12 grid-margin">
                            <div className="card card-rounded">
                              <div className="card-body">
                                <h4 className="card-title">
                                  {isEditMode ? "Update Role Details" : "Add Role Details"}
                                </h4>
                                <div className="row">
                                  <div className="col-12 col-md-12 col-lg-12">
                                    <div className="form-group">
                                      <label>
                                        Name <span className="text-danger">*</span>
                                      </label>
                                      <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter Name"
                                        value={roleName}
                                        onChange={(e) => setRoleName(e.target.value)}
                                      />
                                    </div>
                                  </div>

                                  <div className="col-12 col-md-6 col-lg-6 mt-3">
                                    <label>Permissions</label>
                                    <div className="form-group">
                                      {permissions.map((permission) => (
                                        <div className="form-check" key={permission.id}>
                                          <input
                                            className="form-check-input"
                                            type="checkbox"
                                            id={`perm-${permission.id}`}
                                            checked={permission.permission}
                                            onChange={() =>
                                              handlePermissionChange(permission.id)
                                            }
                                          />
                                          <label
                                            className="form-check-label"
                                            htmlFor={`perm-${permission.id}`}
                                          >
                                            {permission.label}
                                          </label>
                                        </div>
                                      ))}
                                    </div>
                                  </div>
                                </div>

                                <div className="mt-4">
                                  <button className="btn btn-primary" onClick={handleSubmit}>
                                    {isEditMode ? "Update Role" : "Save Role"}
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div> {/* col-lg-12 */}
                    </div> {/* row */}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <LoadingModal isLoading={isLoading} />
          <Notification />
        </div>
      )}
    </>
  );
};

export default AddStaffRoll;
